import {
  ContentLayout,
  CustomDetailsList,
  CustomeDialog,
  HeaderBreadcrumbs,
  Loader,
  LoadingButton,
} from "../../../shared";
import { Button, Chip, Stack, Typography } from "@mui/material";
import { useStripeConnectDetails } from "../hooks/useStripeConnectDetails";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const StripeConnecDetails = () => {
  const { state, isEditable, handleModal, handleStoreConnect } =
    useStripeConnectDetails();
  const { isLoading, details, isOpenConnect, isSaveButton } = state;

  const columns = [
    {
      title: "Stripe ID",
      accessor: (val) => {
        return val.stripe_account_id ? val.stripe_account_id : "--";
      },
    },
  ];

  return (
    <>
      <ContentLayout
        title={details.name ?? ""}
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: "/store-admin/" },
              { name: details?.name },
            ]}
          />
        }
        chipType={"other"}
        statusContent={
          <>
            <Chip
              label={state.details?.stripe_connect_status ? "Connected" : "Disconnected"}
              variant="outlined"
              size="small"
              deleteIcon={
                state.details?.stripe_connect_status ? (
                  <CheckCircleIcon sx={{ color: "#0F875B !important" }} />
                ) : undefined
              }
              onDelete={state.details?.stripe_connect_status ? () => {} : undefined}
              sx={{
                border: "none !important",
                background: state.details?.stripe_connect_status ? "#E1FBF2" : "#e6e6e6",
              }}
            />
          </>
        }
      >
        {isLoading ? (
          <Loader />
        ) : (
          <CustomDetailsList
            columns={columns}
            data={details}
            title="Details"
            headerRightContent={
              <>
                {isEditable && (
                  <>
                    {details.stripe_connect_status ? (
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => handleModal("connect", true)}
                      >
                        Disconnect
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => handleModal("connect", true)}
                      >
                        Connect
                      </Button>
                    )}
                  </>
                )}
              </>
            }
          />
        )}
      </ContentLayout>

      <CustomeDialog
        open={isOpenConnect}
        handleClose={() => handleModal("connect", false, null)}
        PaperProps={{
          sx: { width: "423px", height: "155px", p: "16px" },
        }}
        title={`${
          details?.stripe_connect_status == "1" ? "Disconnect" : "Connect"
        } Stripe`}
        content={
          <Stack
            mt="8px"
            gap="10px"
            height="100%"
            justifyContent="space-between"
          >
            <Typography variant="subtitle2">
              Are you sure you want to{" "}
              {details?.stripe_connect_status == "1" ? "disconnect" : "connect"}{" "}
              Stripe for {details?.name}?
            </Typography>
            <Stack direction="row" justifyContent="end" gap={2}>
              <Button
                variant="text"
                onClick={() => handleModal("connect", false, null)}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={isSaveButton}
                variant="contained"
                color={
                  details?.stripe_connect_status == "1" ? "error" : "primary"
                }
                onClick={() => handleStoreConnect(details)}
              >
                {details?.stripe_connect_status == "1"
                  ? "Disconnect"
                  : "Connect"}
              </LoadingButton>
            </Stack>
          </Stack>
        }
      />
    </>
  );
};
